export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Места хранения",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
